import common from './common.json';
import auth from './auth.json';
import dashboard from './dashboard.json';
import settings from './settings.json';
import subscription from './subscription.json';

export default {
  common,
  auth,
  dashboard,
  settings,
  subscription,
};
